import axios from 'axios';
import { API_URL, AUTH_URL, LOGIN_URL, REFRESH_TOKEN_URL } from '../config';

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Thêm interceptor để xử lý token
axiosInstance.interceptors.request.use(
  (config) => {
    // Đảm bảo headers luôn tồn tại
    if (!config.headers) {
      config.headers = {} as any;
    }
    
    // Nếu body là FormData, xóa Content-Type để browser tự set với boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    // Lấy token từ localStorage
    try {
      const token = localStorage.getItem('access_token');
      if (token) {
        // Kiểm tra xem token đã có prefix Bearer chưa
        const tokenWithBearer = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
        config.headers.Authorization = tokenWithBearer;
      }
    } catch (error) {

    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Thêm interceptor để xử lý response
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Nếu token hết hạn (401) và chưa thử refresh
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refresh_token');
        const response = await axios.post(REFRESH_TOKEN_URL, {
          refresh_token: refreshToken
        });

        const { access_token } = response.data;
        localStorage.setItem('access_token', access_token);

        // Thử lại request ban đầu với token mới
        const tokenWithBearer = access_token.startsWith('Bearer ') ? access_token : `Bearer ${access_token}`;
        originalRequest.headers.Authorization = tokenWithBearer;
        return axiosInstance(originalRequest);
      } catch (error) {
        // Nếu refresh token cũng hết hạn, logout user
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = LOGIN_URL;
        return Promise.reject(error);
      }
    }

    // KPI/OKR: backend trả 403 cho user tư vấn nhà thầu — đưa về module TVNT
    if (error.response?.status === 403 && originalRequest) {
      const reqUrl = String(originalRequest.url || '');
      const data = error.response.data as { message?: string } | undefined;
      const msg = typeof data?.message === 'string' ? data.message : '';
      const isKpiOkrApi = /\/kpi(\/|$)/.test(reqUrl) || /\/okr(\/|$)/.test(reqUrl);
      if (isKpiOkrApi && msg.includes('tư vấn nhà thầu') && msg.includes('KPI')) {
        window.location.assign('/tuvan_nhathau');
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance; 